<template>
  <div v-if="story !== null">
    <!-- 案例資訊 -->
    <div class="block mb-5">
      <!-- 應用產品 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>應用產品</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="story.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- Application -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>應用[Application]</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="story.bu_application_details_id"
            :items="applications"
            placeholder="請選擇所屬Application"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- 客戶 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>客戶</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="story.customer"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 威剛解決方案 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>威剛解決方案</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="story.solution"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="story.status"></FormSwitch>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="story.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="story.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於新聞列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="story.cover_image"
            dir="story"></ImgUploader>
        </div>
      </div>
      <!-- Summary -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Summary</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-textarea
            v-model="story.summary"
            outlined
            dense
          ></v-textarea>
        </div>
      </div>
      <!-- SEO TITLE -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">SEO Title</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="story.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- SEO Description -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">SEO Description</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="story.seo_description"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="story.content"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    Editor,
  },
  data: () => ({
    status: true,
    applications: [],
  }),
  async created() {
    if (this.story.bu_application_details_id !== null) {
      this.applications = await this.getApplications(this.story.bu_application_details_id);
    }
  },
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('story', ['story']),
  },
  watch: {
    async 'story.bu_application_details_id'(newValue) {
      if (newValue !== '') {
        this.applications = await this.getApplications(newValue);
      } else {
        this.applications = [];
      }
    },
  },
  methods: {
    ...mapActions('story', ['getApplications']),
  },
};
</script>

<style></style>
